import {
  fetchPhotos as fetchPhotosApi,
  deletePhoto as deletePhotoApi,
  uploadPhoto as uploadFilePhotoApi,
  updatePhotos as updatePhotosApi,
  updateMainPhoto as updateMainPhotoApi,
  rotatePhotoClockwise as rotatePhotoClockwiseApi,
  fetchRoomsSuggestions as fetchRoomsSuggestionsApi,
} from 'api/photoManager';
import {
  DELETE_PHOTO,
  FETCH_PHOTOS,
  UPDATE_MAIN_PHOTO,
  ROTATE_PHOTO,
  HAS_FINISHED_PHOTOS_UPLOAD,
  HAS_STARTED_PHOTOS_UPLOAD,
  ERROR_MESSAGE,
  UPDATE_LIST_PHOTOS,
  UPDATE_PHOTOS,
  UPDATE_DESCRIPTION_ON_PHOTO_LIST,
  CHANGE_DROPZONE_VISIBILITY,
  UPDATE_HAS_SNACK_BAR,
  ADD_PHOTOS_TO_UPLOAD,
  FETCH_ROOM_SUGGESTIONS,
} from './types';

export const deletePhotosAction = (photoId, galleryType, houseId) => ({
  type: DELETE_PHOTO,
  meta: {
    photoId,
  },
  promise: deletePhotoApi(photoId, galleryType, houseId),
});

export const fetchPhotosAction = (houseType, houseId, galleryType) => ({
  type: FETCH_PHOTOS,
  promise: fetchPhotosApi(houseType, houseId, galleryType),
});

export const uploadPhotoAction = (houseType, houseId, file, galleryType) => ({
  type: HAS_FINISHED_PHOTOS_UPLOAD,
  promise: uploadFilePhotoApi(houseType, houseId, file, galleryType),
});

export const updateMainPhotoAction = (id, houseId, width, height) => ({
  type: UPDATE_MAIN_PHOTO,
  meta: {
    id,
  },
  promise: updateMainPhotoApi(id, houseId, width, height),
});

export const rotatePhotoClockwiseAction = (propertyId, photoId) => ({
  type: ROTATE_PHOTO,
  meta: {
    photoId,
  },
  promise: rotatePhotoClockwiseApi(propertyId, photoId, 'clockwise'),
});

export const hasStartedPhotoUploadAction = () => ({
  type: HAS_STARTED_PHOTOS_UPLOAD,
});

export const errorMessageAction = (message) => ({
  type: ERROR_MESSAGE,
  extraProperties: {
    message,
  },
});

export const updatePhotosListAction = (photos) => ({
  type: UPDATE_LIST_PHOTOS,
  extraProperties: {
    photos,
  },
});

export const updatePhotosAction = (photoList, galleryType, houseId) => ({
  type: UPDATE_PHOTOS,
  promise: updatePhotosApi(photoList, galleryType, houseId),
});

export const setUpdateDescriptionAction = (id, description) => ({
  type: UPDATE_DESCRIPTION_ON_PHOTO_LIST,
  extraProperties: {
    id,
    description,
  },
});

export const changeDropZoneVisibilityAction = (visibility) => ({
  type: CHANGE_DROPZONE_VISIBILITY,
  extraProperties: {
    visibility,
  },
});

export const updateHasSnackBarAction = (state) => ({
  type: UPDATE_HAS_SNACK_BAR,
  extraProperties: {
    state,
  },
});

export const addPhotosToUploadAction = (photosToUpload) => ({
  type: ADD_PHOTOS_TO_UPLOAD,
  extraProperties: {
    photosToUpload,
  },
});

export const fetchRoomsSuggestionsAction = () => ({
  type: FETCH_ROOM_SUGGESTIONS,
  promise: fetchRoomsSuggestionsApi(),
});
